exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.red {\n\tcolor: #f00;\n}\n", "", {"version":3,"sources":["/Users/ryanblaind/Dropbox/Work/dev/shopify-modern/src/views/PageView.vue?5be56c76"],"names":[],"mappings":";AAwBA;CACA,YAAA;CACA","file":"PageView.vue","sourcesContent":["/*\n\tgeneric Page component\n*/\n\n<template>\n\t<div>\n\t\t<h1 class=\"red\">Page View</h1>\n\t</div>\n\n</template>\n\n\n<script>\n\texport default {\n\n\t\tdata () {\n\t\t\treturn {\n\t\t\t}\n\t\t}\n\t}\n</script>\n\n\n<style>\n\t.red {\n\t\tcolor: #f00;\n\t}\n</style>\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-39e3e20b","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/PageView.vue
// module id = 30
// module chunks = 0